"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LiveWorkItemState;
(function (LiveWorkItemState) {
    LiveWorkItemState["Active"] = "Active";
    LiveWorkItemState["Closed"] = "Closed";
    LiveWorkItemState["Open"] = "Open";
    LiveWorkItemState["Waiting"] = "Waiting";
    LiveWorkItemState["WrapUp"] = "WrapUp";
})(LiveWorkItemState || (LiveWorkItemState = {}));
exports.default = LiveWorkItemState;
//# sourceMappingURL=LiveWorkItemState.js.map